import type { QueryProps } from '@/api/api'

/**
 * Normalises the `query` prop into a consistent array form.
 * Handles the three valid inputs: undefined, a single query, or an array.
 */
export function normaliseChartQuery(query: QueryProps | QueryProps[] | undefined): QueryProps[] {
  if (!query) return []
  return Array.isArray(query) ? query : [query]
}

/**
 * Returns the overrides object from the first result that carries one,
 * or undefined when no result has overrides.
 */
export function findFirstOverrides(
  results: Array<{ data?: { overrides?: unknown } | null }>,
): unknown {
  for (const item of results) {
    if (item.data?.overrides) return item.data.overrides
  }
  return undefined
}
